import { render, staticRenderFns } from "./InvoiceType.vue?vue&type=template&id=56ff5e5e"
import script from "./InvoiceType.vue?vue&type=script&lang=js"
export * from "./InvoiceType.vue?vue&type=script&lang=js"
import style0 from "./InvoiceType.vue?vue&type=style&index=0&id=56ff5e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports